import React from "react";
import { Grid, IconButton } from "@material-ui/core";
import { faFileDownload, faPrint, faEye } from "@fortawesome/free-solid-svg-icons";

import { Icon } from "../childrens/Icon/.mixins";

import { css } from "./styles";

export function IconsGrid({ isInsideModal, handleClickIconDownload, handleClickIconView, handleClickIconPrint }) {
    const styles = css();

    return (
        <>
            <Grid className={styles.grid_icons}>
                {isInsideModal && (
                    <IconButton onClick={handleClickIconView}>
                        <Icon tooltip_title="Visualizar" icon={faEye} />
                    </IconButton>
                )}
                <IconButton onClick={handleClickIconDownload}>
                    <Icon tooltip_title="Fazer Download" icon={faFileDownload} />
                </IconButton>
                <IconButton onClick={handleClickIconPrint}>
                    <Icon tooltip_title="Imprimir" icon={faPrint} />
                </IconButton>
            </Grid>
        </>
    );
}
